const modalSupportTextField = {
  label: 'Descrição'
};

export default modalSupportTextField;
